module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado12.8d2962eb.svg";